import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import styles from "../../styles/components/searchFigma/PickMultiModal.module.css";

export default function PickMultiModal({
  isOpen,
  closeModal,
  onFilterApply,
  options, // ✔ manufacturerLists → options 이름 변경
  type, // "manufacturer" | "distributor"
}) {
  const router = useRouter();
  const { query } = router;
  const modalRef = useRef(null);

  // ---------------------------------------------
  // ① URL → 배열 변환 (제조사/유통사 분기)
  // ---------------------------------------------
  const selectedFromUrl = (() => {
    if (type === "manufacturer") {
      return query.manufacturer
        ? decodeURIComponent(query.manufacturer).split(",")
        : [];
    }
    if (type === "distributor") {
      return query.source ? decodeURIComponent(query.source).split(",") : [];
    }
    return [];
  })();

  // 내부 선택 상태
  const [selectedList, setSelectedList] = useState(selectedFromUrl);

  // URL 변경되면 내부 상태도 반영
  useEffect(() => {
    setSelectedList(selectedFromUrl);
  }, [query.manufacturer, query.source]);

  // 모달 열릴 때 transform 초기화
  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.style.transform = "translateY(0)";
    }
  }, [isOpen]);

  // ---------------------------------------------
  // ② 선택 toggle (local state만 변경)
  // ---------------------------------------------
  const handleSelect = (value) => {
    setSelectedList((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  // ---------------------------------------------
  // ③ 적용하기 → 부모에게 전달 + URL 업데이트
  // ---------------------------------------------
  const handleApply = () => {
    const array = [...selectedList];

    if (type === "manufacturer") {
      onFilterApply(
        "keyword",
        array,
        query.source ? decodeURIComponent(query.source).split(",") : [] // ← FIX!!
      );
    }

    if (type === "distributor") {
      onFilterApply(
        "keyword",
        query.manufacturer
          ? decodeURIComponent(query.manufacturer).split(",")
          : [], // ← FIX!!
        array
      );
    }
    closeModal();
  };

  // 초기화 → 모두 선택 해제
  const handleInit = () => {
    setSelectedList([]);
  };

  // ---------------------------------------------
  // ④ 바텀시트 Drag
  // ---------------------------------------------
  const [startY, setStartY] = useState(0);
  const [currentY, setCurrentY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = (e) => {
    setIsDragging(true);
    setStartY(e.touches ? e.touches[0].clientY : e.clientY);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    const y = e.touches ? e.touches[0].clientY : e.clientY;
    const diff = y - startY;
    if (diff > 0 && modalRef.current) {
      modalRef.current.style.transform = `translateY(${diff}px)`;
      setCurrentY(diff);
    }
  };

  const handleDragEnd = () => {
    if (!isDragging) return;
    setIsDragging(false);
    if (currentY > 100) closeModal();
    else if (modalRef.current) {
      modalRef.current.style.transition = "transform 0.3s ease";
      modalRef.current.style.transform = "translateY(0)";
      setTimeout(() => {
        if (modalRef.current) modalRef.current.style.transition = "";
      }, 300);
    }
  };

  // ---------------------------------------------
  // RETURN
  // ---------------------------------------------
  return (
    <>
      <div
        className={`${styles.modalOverlay} ${isOpen ? styles.show : ""}`}
        onClick={closeModal}
      >
        <div
          ref={modalRef}
          className={`${styles.modalContainer} ${isOpen ? styles.slideUp : ""}`}
          onClick={(e) => e.stopPropagation()}
          onMouseMove={handleDragMove}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
        >
          {/* drag handle */}
          <div
            className={styles.bottomSheetHandle}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
          >
            <div className={styles.handle}></div>
          </div>

          {/* 리스트 */}
          <div className={styles.Frame1101}>
            {options.map((item, index) => {
              const isActive = selectedList.includes(item);

              return (
                <div
                  key={`${item}-${index}`}
                  className={styles.buttonText}
                  onClick={() => handleSelect(item)}
                >
                  <div
                    className={`${
                      isActive ? styles.activeText : styles.inactiveText
                    } body3`}
                  >
                    {item}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div className={styles.component2}>
            <div className={styles.buttonFillLight} onClick={handleInit}>
              <div className={`${styles.buttonInit} body3`}>초기화</div>
            </div>

            <div className={styles.buttonFillPrimary} onClick={handleApply}>
              <div className={`${styles.redbutton} body3`}>적용하기</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
